export const FEATURES = {
  PLAN_EDIT_ENABLED: false,
};
